/* eslint-disable no-unused-vars */
export var SupportedSound;
(function (SupportedSound) {
    SupportedSound["QUACK"] = "QUACK";
    SupportedSound["DICE_ROLL"] = "DICE_ROLL";
    SupportedSound["ERROR"] = "ERROR";
    SupportedSound["APPLAUSE"] = "APPLAUSE";
    SupportedSound["WHISTLE"] = "WHISTLE";
    SupportedSound["SHOOT"] = "SHOOT";
    SupportedSound["HYPERLIKE"] = "HYPERLIKE";
    SupportedSound["POUFFF"] = "POUFFF";
    SupportedSound["TICK"] = "TICK";
})(SupportedSound || (SupportedSound = {}));
